import React, { useState, useEffect, useRef } from "react";
import { BsSnapchat, BsTwitterX } from "react-icons/bs";
import { CiFacebook, CiLinkedin, CiYoutube } from "react-icons/ci";
import {
  IoLogoInstagram,
  IoMailOutline,
  IoPhonePortraitOutline,
} from "react-icons/io5";
import { PiCaretDownBold, PiTiktokLogo } from "react-icons/pi";
import { TbWorld } from "react-icons/tb";
import NavHeader from "./NavHeader";
import i18n from "../il8n";
import { getAvailableLanguages, getLanguageDisplayName } from "../utils/languageUtils";

const NavBar = () => {
  const [activeLanguage, setActiveLanguage] = useState(i18n.language);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const availableLanguages = getAvailableLanguages();
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    localStorage.setItem("selectedLanguage", lng);
    i18n.changeLanguage(lng);
    setActiveLanguage(lng);
    setIsDropdownOpen(false); // Close dropdown after selection
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Sync activeLanguage with i18n language changes
  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setActiveLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);

    // Set initial language from localStorage
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage);
    }

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  return (
    <>
      <div className=" w-[100%] flex h-12 bg-[#003E6F] justify-center items-center no-scrollbar">
        <div className="w-[90%] flex justify-between items-center">
          <div className={`flex flex-row items-center gap-3`}>
            <a href="https://twitter.com/fawazlawyer" target="_blank">
              <BsTwitterX size={20} className="  text-white" />
            </a>
            <a href="#" target="_blank">
              <CiFacebook size={25} className="  text-white" />
            </a>
            <a href="https://www.instagram.com/fawazlawyer_/" target="_blank">
              <IoLogoInstagram size={22} className="  text-white" />
            </a>
            <a href="#" target="_blank" className=" flex">
              <CiLinkedin size={25} className="  text-white" />
            </a>
            <a
              href="https://www.youtube.com/@المحاميفوازالداهش"
              target="_blank"
              className=" flex"
            >
              <CiYoutube size={25} className="  text-white" />
            </a>
            <a
              href="https://wa.me/966920013767"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 pl-2"
            >
              <IoPhonePortraitOutline size={18} className="text-white" />
              <p className="text-white text-sm">+966920013767</p>
            </a>

            <a
              href="mailto:info@fawazlaw.sa"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 pl-2"
            >
              <IoMailOutline size={20} className="text-white" />
              <p className="text-white text-sm">info@fawazlaw.sa</p>
            </a>
          </div>
          <div className="items-center gap-4 flex">
            <div className="relative" ref={dropdownRef}>
              <div
                className="px-3 py-2 flex text-white items-center gap-[3px] cursor-pointer hover:bg-[#004080] rounded-md transition-colors"
                onClick={toggleDropdown}
              >
                <PiCaretDownBold className={`transform transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                <p className="hidden sm:block">{getLanguageDisplayName(activeLanguage) || activeLanguage}</p>
                <p className="sm:hidden">{activeLanguage.toUpperCase()}</p>
                <TbWorld />
              </div>

              {/* Dropdown Menu */}
              {isDropdownOpen && (
                <div className="absolute top-full right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50 min-w-[120px]">
                  {availableLanguages
                    .filter(lang => lang.code !== activeLanguage)
                    .map(lang => (
                      <div
                        key={lang.code}
                        className="px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer text-right border-b border-gray-100 last:border-b-0"
                        onClick={() => changeLanguage(lang.code)}
                      >
                        {lang.name}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <NavHeader />
    </>
  );
};

export default NavBar;
